import { InjectionToken } from '@angular/core';

/**
 * Maptiler API key — provided by each app (inside, integrator, customer) and consumed
 * by services that build a maplibre style URL. Lives in {@code shared-map-libre} so
 * shared map services can read it without depending on app-specific environment shapes
 * (the inside app exposes it via {@code INSIDE_APP_ENVIRONMENT.maptiles}, the integrator
 * via its own provider — both now wrap that into this single token).
 */
export const MAPTILES_KEY = new InjectionToken<string>('MAPTILES_KEY');
